import PropTypes from 'prop-types';
import Button from 'components/UI/Button';
import Switch from 'components/UI/Switch';

export const REQUIRED_PERMISSION_KEYS = ['privacy', 'terms', 'bureau'];

const PermissionsScreen = ({
  literals,
  permissions,
  onPermissionChange,
  onAccept,
  onBack,
  onOpenDocument,
}) => {
  const allAccepted = REQUIRED_PERMISSION_KEYS.every((key) => permissions[key]);

  return (
    <div className='full-screen-container digital-loan-permissions'>
      <div className='screen-content'>
        <h1 className='digital-loan-permissions__title'>{literals.title}</h1>
        <p className='digital-loan-permissions__intro'>{literals.intro1}</p>
        <p className='digital-loan-permissions__intro digital-loan-permissions__intro--last'>
          {literals.intro2}
        </p>
        <div className='digital-loan-permissions__list'>
          {REQUIRED_PERMISSION_KEYS.map((key) => (
            <div key={key} className='digital-loan-permissions__row'>
              <button
                type='button'
                className='digital-loan-permissions__label'
                onClick={() => onOpenDocument(key)}
              >
                {literals.labels[key]}
              </button>
              <Switch
                checked={permissions[key]}
                onChange={() => onPermissionChange(key)}
              />
            </div>
          ))}
        </div>
      </div>
      <div className='screen-actions digital-loan-permissions__actions'>
        <Button
          text={literals.accept}
          disabled={!allAccepted}
          onClick={onAccept}
          limitToOneClick
        />
        <Button text={literals.back} type='secondary' onClick={onBack} />
      </div>
    </div>
  );
};

PermissionsScreen.propTypes = {
  literals: PropTypes.object.isRequired,
  permissions: PropTypes.object.isRequired,
  onPermissionChange: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onOpenDocument: PropTypes.func.isRequired,
};

export default PermissionsScreen;
